export default {
	INGREDIENT_PRODUCT_ASSOCIATION: 'Ingrediend association with products',
	INGREDIENT_ASSOCIATION_DELETED:
		'Ingredient accociation with product deleted.',
	INGREDIENT_ASSOCIATION_ADDED: 'Ingredient association with product added.'
};
